import { render, staticRenderFns } from "./Box6new.vue?vue&type=template&id=15bdb996&scoped=true&"
import script from "./Box6new.vue?vue&type=script&lang=js&"
export * from "./Box6new.vue?vue&type=script&lang=js&"
import style0 from "./Box6new.vue?vue&type=style&index=0&id=15bdb996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bdb996",
  null
  
)

export default component.exports